import { render, staticRenderFns } from "./TiltCard.vue?vue&type=template&id=724e7300&scoped=true&lang=pug"
import script from "./TiltCard.vue?vue&type=script&lang=js"
export * from "./TiltCard.vue?vue&type=script&lang=js"
import style0 from "./TiltCard.vue?vue&type=style&index=0&id=724e7300&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e7300",
  null
  
)

export default component.exports